import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";

const Showalert = ({ title, message }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const elems = document.getElementsByClassName('custom-alert-pop');
    for (let i = 0; i < elems.length; i += 1) {
      elems[i].style.display = 'block';
    }
  }, []);

  const popupClose = () => {
    const elems = document.getElementsByClassName('custom-alert-pop');
    for (let i = 0; i < elems.length; i += 1) {
      elems[i].style.display = 'none';
    }
    window.location.reload();
  };

  return (
    <div
      className="custom-alert-pop"
      style={{ display: "block" }}
    >
      <div className="custom-alert-container">
        <div className="custom-alert-wrap">
          <div className="custom-alert-header">
            <h4>{title}</h4>
          </div>
          <div className="custom-alert-body">
            <p>{message}</p>
            <div className="alert-buttons">
              <a
                title={t("ok_txt")}
                onClick={popupClose}
                className="popup-alert-btn button"
              >
                {t("ok_txt")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Showalert;